import type { Simplify } from '..';

type IsEqual<T, U> =
  (<G>() => G extends T ? 1 : 2) extends <G>() => G extends U ? 1 : 2
    ? true
    : false;
type Filter<KeyType, ExcludeType> =
  IsEqual<KeyType, ExcludeType> extends true
    ? never
    : KeyType extends ExcludeType
      ? never
      : KeyType;
type Except<ObjectType, KeysType> = {
  [
    KeyType in keyof ObjectType as Filter<KeyType, KeysType>
  ]: ObjectType[KeyType];
};

export type _InternalMerge<FirstType, SecondType> = Simplify<
  Except<FirstType, Extract<keyof FirstType, keyof SecondType>> & SecondType
>;

export type UnionToIntersection<Union> = (
  Union extends unknown ? (distributedUnion: Union) => void : never
) extends (mergedIntersection: infer Intersection) => void
  ? Intersection
  : never;
